var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import './types/globals';
import { spenttimeDebug as debug } from './modules/debug';
import { startMeasurement } from './modules/spenttime/measurement';
/**
 * Expose to global object
 */
var output = {
    startMeasurement: startMeasurement,
    conf: function () { return null; },
};
/**
 * The main method. Initializing
 */
var initComponentSpenttime = function () {
    window.sznIVA = __assign(__assign({}, (window.sznIVA || {})), { spenttime: output });
    debug('window.sznIVA.spenttime added to the window-object');
};
initComponentSpenttime();
export default output;
